/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createAccountGetResponseFromDiscriminatorValue, serializeAccountPostRequest, type AccountGetResponse, type AccountPostRequest } from '../models';
// @ts-ignore
import { type WithAccountItemRequestBuilder, WithAccountItemRequestBuilderNavigationMetadata, WithAccountItemRequestBuilderRequestsMetadata } from './item';
// @ts-ignore
import { OverviewRequestBuilderRequestsMetadata, type OverviewRequestBuilder } from './overview';
// @ts-ignore
import { type BaseRequestBuilder, type Guid, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /accounts
 */
export interface AccountsRequestBuilder extends BaseRequestBuilder<AccountsRequestBuilder> {
    /**
     * The overview property
     */
    get overview(): OverviewRequestBuilder;
    /**
     * Gets an item from the MoneyChecker.Web.ApiClient.accounts.item collection
     * @param accountId The Guid identifier of the account to retrieve
     * @returns {WithAccountItemRequestBuilder}
     */
     byAccountId(accountId: Guid) : WithAccountItemRequestBuilder;
    /**
     * Retrieves a list of all accounts
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<AccountGetResponse[]>}
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<AccountGetResponse[] | undefined>;
    /**
     * Creates a new account
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<Guid>}
     */
     post(body: AccountPostRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<Guid | undefined>;
    /**
     * Retrieves a list of all accounts
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * Creates a new account
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: AccountPostRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const AccountsRequestBuilderUriTemplate = "{+baseurl}/accounts";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const AccountsRequestBuilderNavigationMetadata: Record<Exclude<keyof AccountsRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byAccountId: {
        requestsMetadata: WithAccountItemRequestBuilderRequestsMetadata,
        navigationMetadata: WithAccountItemRequestBuilderNavigationMetadata,
        pathParametersMappings: ["accountId"],
    },
    overview: {
        requestsMetadata: OverviewRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const AccountsRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: AccountsRequestBuilderUriTemplate,
        responseBodyContentType: "text/plain;q=0.9",
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createAccountGetResponseFromDiscriminatorValue,
    },
    post: {
        uriTemplate: AccountsRequestBuilderUriTemplate,
        responseBodyContentType: "text/plain;q=0.9",
        adapterMethodName: "sendPrimitive",
        responseBodyFactory:  "string",
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeAccountPostRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
